import rendercarousels from './carousels/carousels.js'
import renderIcons from './renderIcons.js'
import renderHeader from './header.js'
// import containerHeight from './containerHeight'
import printBlock from './printBlock.js'
import copyLink from './copyLink.js'
import gradient from './gradient.js'
import animations from './animations.js'
import activeMenuLink from './activeMenuLink.js'
import programPopup from './programPopup.js'
// import videoPlayer from './player/videoPlayer.js'
// import quote_1 from './quote_1/index.js'
// import quote_2 from './quote_2/index.js'
import poster from './poster/index.js'
import popup from './quiz/popup.js'
import programList from './programList.js'
// Импортируем оба виджета
import CookieWidget from './cookieWidget.js';
import SocialPopupWidget from './socialPopup.js';
import { RemoveViqeo } from './remove-viqeo.js';
import './css/app.scss'
document.addEventListener('DOMContentLoaded', () => {
	popup()
	rendercarousels()
	renderIcons()
	renderHeader()
	copyLink()
	gradient()
	// containerHeight()
	printBlock()
	animations()
	activeMenuLink()
	programPopup()
	programList()
	//	videoPlayer()
	const CWidget = new CookieWidget({
		cookieName: 'TVCookie',
		cookieExpiryHrs: 48, // Cookie на 48 часов
		cookieTheme: 'is-mzk', //  3 темы: дефолтная, тёмная, is-mzk
		cookieHtml: '<h3>Мы используем cookie <fieldset class="acceptPolicy"><button class="btn" id="cookieSwitch">OK</button></fieldset></h3><p><a target="_blank" href="https://digitalrussia.tv">АО «ЦТВ»</a> использует <a target="_blank" href="https://digitalrussia.tv/dtr_cookie_policy.pdf">cookie-файлы</a> и обрабатывает <a target="_blank" href="https://digitalrussia.tv/dtr_personal_data_processing_policy.pdf">персональные данные</a> для улучшения работы сайта. Подтвердите ваше согласие, нажав кнопку</p>', // если надо заменить html виджета
		cookieScroll: 200 // если задан, то виджет инициализируется по скроллу, типа 100px
	});
	const socialPopup = new SocialPopupWidget({
		ctCookieName: 'TVCookie', // имя cookie
		ctScrollY: 350,
		ctClass: 'is-mzk from-top',
		ctDNDExpireDays: 0.06, // Хранить cookie о закрытии 0.1 дней
		ctHTML: ['<div class="mzk-txt"><a onclick="ym(\'90341278\', \'reachGoal\', \'tgPromo01\', {\'widget\': \'telegram-top-1\'}); return true;" class="mzk-full-announce" target="_blank" rel="noopener noreferrer" href="https://t.me/+eDvF9PZri6w5Y2Ri"><div class="mzk-icon mzk-tg"></div><p>В какой кинороли никто не узнал <strong>Людмилу Гурченко</strong>? Всё о советских фильмах, актёрах и режиссёрах рассказываем здесь — подписывайся!</p></a></div>',
			'<div class="mzk-txt gr1"><a onclick="ym(\'90341278\', \'reachGoal\', \'tgPromo02\', {\'widget\': \'telegram-top-2\'}); return true;" class="mzk-full-announce" target="_blank" rel="noopener noreferrer" href="https://t.me/+eDvF9PZri6w5Y2Ri"><div class="mzk-icon mzk-tg"></div><p>Откуда взялись кудри у <strong>Владимира Меньшова</strong> в фильме «Любовь и голуби»? Секреты кино в нашем канале. Подписывайся!</p></a></div>',
			'<div class="mzk-txt gr2"><a onclick="ym(\'90341278\', \'reachGoal\', \'tgPromo03\', {\'widget\': \'telegram-top-3\'}); return true;" class="mzk-full-announce" target="_blank" rel="noopener noreferrer" href="https://t.me/+eDvF9PZri6w5Y2Ri"><div class="mzk-icon mzk-tg"></div><p>После съёмок какого фильма голос <strong>Василия Ливанова</strong>, знаменитого ролями в кино и озвучиванием мультфильмов, изменился навсегда? Всё о советских фильмах тут — подписывайся!</p></a></div>',
			'<div class="mzk-txt gr3"><a onclick="ym(\'90341278\', \'reachGoal\', \'tgPromo04\', {\'widget\': \'telegram-top-4\'}); return true;" class="mzk-full-announce" target="_blank" rel="noopener noreferrer" href="https://t.me/+eDvF9PZri6w5Y2Ri"><div class="mzk-icon mzk-tg"></div><p>Кто сыграл ноги графа Калиостро в фильме «Формула любви» и почему этого не сделал <strong>Нодар Мгалоблишвили</strong>? Всё о кино в нашем канале. Подписывайся!</p></a></div>']
	});
	const viqeoRemover = new RemoveViqeo({
		debug: true // для отладки
	});
	document.querySelector('#poster') ? poster() : null
	document.querySelector('#test-mosfilm') ? quote_2() : null
	document.querySelector('#test-mosfilm-1') ? quote_1() : null
});
window.addEventListener('load', () => {
	document.querySelector('.load').classList.remove('load')
})